(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-video-carousel"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    root.querySelectorAll('[data-atelier-stories]').forEach((section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      const track = section.querySelector('[data-stories-track]');
      const previous = section.querySelector('[data-stories-prev]');
      const next = section.querySelector('[data-stories-next]');
      if (!track) return;

      const step = () => {
        const card = track.querySelector('.atelier-story');
        if (!card) return track.clientWidth;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 16;
        return card.getBoundingClientRect().width + gap;
      };

      const update = () => {
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        if (previous) previous.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= maxScroll - 2;
        section.classList.toggle('atelier-stories--static', maxScroll <= 2);
      };

      previous?.addEventListener('click', () => {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });

      next?.addEventListener('click', () => {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      requestAnimationFrame(update);
    });
  };

  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
function setupAtelierFooter(){const mobile=window.matchMedia('(max-width: 740px)');const groups=document.querySelectorAll('.ah-footer-group');const sync=()=>groups.forEach(group=>{group.open=!mobile.matches;});sync();mobile.addEventListener('change',sync);groups.forEach(group=>group.querySelector('summary').addEventListener('click',event=>{if(!mobile.matches)event.preventDefault();}));}
setupAtelierFooter();
document.addEventListener('shopify:section:load',setupAtelierFooter);

document.querySelectorAll('.ah-ugc').forEach(section=>{
const track=section.querySelector('.ah-ugc-track');
section.querySelectorAll('[data-ugc-dir]').forEach(button=>button.addEventListener('click',()=>{const card=track.querySelector('.ah-ugc-card');const step=card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap);const max=track.scrollWidth-track.clientWidth;let next=track.scrollLeft+Number(button.dataset.ugcDir)*step;if(next>max+1)next=0;if(next<0)next=max;track.scrollTo({left:next,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}));
section.querySelectorAll('video').forEach(video=>video.addEventListener('play',()=>section.querySelectorAll('video').forEach(other=>{if(other!==video)other.pause();})));
});

function setupAtelierCollectorTabs(){
 const videos=document.querySelector('.ah-ugc');
 const gallery=document.querySelector('main gallery-list') || document.querySelector('gallery-list');
 if(!videos || !gallery || document.querySelector('.ah-collector-tabs'))return;
 const host=gallery.parentElement;
 host.classList.add('ah-collector-world');
 const heading=host.querySelector('.section__header');
 if(heading){
 heading.classList.add('ah-collector-world-heading');
 const title=heading.querySelector('h3');
 if(title)title.textContent='The Collector’s World';
 const subtitle=heading.querySelector('h2');
 if(subtitle)subtitle.hidden=true;
 }
 const tabs=document.createElement('div');
 tabs.className='ah-collector-tabs';tabs.setAttribute('role','tablist');tabs.setAttribute('aria-label','Explore Atelier Giants');
 const events=document.querySelector('.ah-private-events');
 const panels=events?[gallery,videos,events]:[gallery,videos];
 const names=events?['Collector Gallery','Unboxings','Private Events']:['Collector Gallery','Unboxings'];
 panels.forEach((panel,i)=>{
  panel.id='ah-collector-panel-'+i;panel.classList.add('ah-collector-panel');
  panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby','ah-collector-tab-'+i);
  const tab=document.createElement('button');tab.type='button';tab.id='ah-collector-tab-'+i;
  tab.textContent=names[i];tab.setAttribute('role','tab');tab.setAttribute('aria-controls',panel.id);
  tabs.appendChild(tab);
 });
 host.insertBefore(tabs,gallery);host.appendChild(videos);
 if(events)host.appendChild(events);
 const community=document.querySelector('.ah-instagram-community');
 if(community)host.appendChild(community);

 const buttons=[...tabs.children];
 function select(index,focus){
  buttons.forEach((button,i)=>{button.setAttribute('aria-selected',String(i===index));button.tabIndex=i===index?0:-1;panels[i].hidden=i!==index;});
  panels.forEach((panel,i)=>{if(i!==index)panel.querySelectorAll('video').forEach(video=>video.pause());});
  if(focus)buttons[index].focus();
  window.dispatchEvent(new Event('resize'));
 }
 buttons.forEach((button,i)=>{
  button.addEventListener('click',()=>select(i,false));
  button.addEventListener('keydown',event=>{
   let next;if(event.key==='ArrowRight'||event.key==='ArrowLeft')next=(i+(event.key==='ArrowRight'?1:-1)+panels.length)%panels.length;
   if(event.key==='Home')next=0;if(event.key==='End')next=panels.length-1;
   if(next!==undefined){event.preventDefault();select(next,true);}
  });
 });
 select(0,false);
}
setupAtelierCollectorTabs();
document.addEventListener('shopify:section:load',setupAtelierCollectorTabs);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-collection-banner"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('atelier-hero-offer-banner')) {
  customElements.define('atelier-hero-offer-banner', class extends HTMLElement {
    connectedCallback() {
      clearInterval(this.timer);
      this.deadline = Date.parse(this.dataset.deadline);
      if (!Number.isFinite(this.deadline)) return;
      this.parts = ['days', 'hours', 'minutes', 'seconds'].map(part => this.querySelector('[data-' + part + ']'));
      this.onVisibility = this.onVisibility || (() => this.tick());
      document.addEventListener('visibilitychange', this.onVisibility);
      this.tick();
      if (Date.now() < this.deadline) this.timer = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      document.removeEventListener('visibilitychange', this.onVisibility);
    }
    tick() {
      const remaining = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
      const values = [Math.floor(remaining / 86400), Math.floor(remaining / 3600) % 24, Math.floor(remaining / 60) % 60, remaining % 60];
      this.parts.forEach((part, index) => { part.textContent = String(values[index]).padStart(2, '0'); });
      if (remaining > 0) return;
      clearInterval(this.timer);
      if (this.expired) return;
      this.expired = true;
      this.classList.add('is-expired');
      const status = this.querySelector('[data-offer-status]');
      status.hidden = false;
      status.textContent = this.dataset.expiredMessage;
      this.dispatchEvent(new CustomEvent('atelier:hero-offer-expired', { bubbles: true, detail: { productId: this.dataset.productId } }));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-collection"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('atelier-hero-builder')) {
  customElements.define('atelier-hero-builder', class extends HTMLElement {
    connectedCallback() {
      if (this.listeners) this.listeners.abort();
      this.listeners = new AbortController();
      const signal = this.listeners.signal;
      document.addEventListener('atelier:hero-offer-expired', event => {
        if (event.detail && event.detail.productId === this.dataset.productId) this.applyOfferExpiry();
      }, { signal });
      this.addEventListener('submit', event => this.handleSubmit(event), { capture: true, signal });
      this.applyOfferExpiry();
      if (!this.initialized) {
        try { this.config = JSON.parse(this.querySelector('[data-builder-data]').textContent); } catch (error) { return; }
        this.cards = [...this.querySelectorAll('[data-hero]')];
        this.selected = [];
        this.feedback = this.querySelector('[data-feedback]');
        this.variantInput = this.querySelector('[data-variant]');
        this.reserve = this.querySelector('[data-reserve]');
        this.purchaseForm = this.querySelector('[data-builder-form]');
        this.dialog = this.querySelector('[data-preview-dialog]');
        this.variants = new Map(this.config.variants.map(v => [String(v.id), v]));
        const heroKeysByName = new Map(this.cards.map(card => [card.dataset.name, card.dataset.hero]));
        this.pairs = [...this.variants.values()].map(variant => ({
          id: String(variant.id),
          keys: variant.title.split(' + ').map(name => heroKeysByName.get(name.trim())),
          variant
        })).filter(pair => pair.keys.length === 2 && pair.keys.every(Boolean) && pair.keys[0] !== pair.keys[1]);
        this.cards.forEach(card => { card.disabled = false; });
        this.querySelectorAll('[data-preview]').forEach(button => { button.disabled = !this.dialog || typeof this.dialog.showModal !== 'function'; });
        const requestedVariant = new URL(window.location.href).searchParams.get('variant');
        const requestedPair = this.pairs.find(pair => String(pair.id) === requestedVariant);
        if (requestedPair && requestedPair.variant && requestedPair.variant.available) this.selected = [...requestedPair.keys];
        this.initialized = true;
      }
      this.addEventListener('click', event => {
        const preview = event.target.closest('[data-preview]');
        if (preview && this.contains(preview)) { this.openPreview(preview); return; }
        if (event.target.closest('[data-preview-close]')) { this.dialog.close(); return; }
        const remove = event.target.closest('[data-remove]');
        if (remove && this.contains(remove)) {
          const card = this.cards.find(item => item.dataset.hero === remove.dataset.remove);
          this.toggle(remove.dataset.remove);
          if (card && !remove.isConnected) card.focus({ preventScroll: true });
          return;
        }
        if (event.target.closest('[data-reset]')) {
          if (this.pending || this.applyOfferExpiry()) return;
          this.clearCartStatus();
          this.selected = [];
          this.update();
          return;
        }
        const card = event.target.closest('[data-hero]');
        if (card && this.contains(card)) this.toggle(card.dataset.hero);
      }, { signal });
      if (this.dialog) {
        this.dialog.addEventListener('close', () => {
          if (this.previewTrigger && this.previewTrigger.isConnected) this.previewTrigger.focus({ preventScroll: true });
          this.previewTrigger = null;
          this.scheduleSticky();
        }, { signal });
        this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); }, { signal });
      }
      this.classList.add('is-ready');
      this.setupSticky(signal);
      this.update();
    }
    disconnectedCallback() {
      if (this.listeners) this.listeners.abort();
      if (this.requestAbort) this.requestAbort.abort();
      clearTimeout(this.requestTimeout);
      this.teardownSticky();
      this.previewTrigger = null;
      if (this.dialog && this.dialog.open) this.dialog.close();
    }
    openPreview(button) {
      const card = this.cards.find(item => item.dataset.hero === button.dataset.preview);
      const source = card && card.querySelector('img');
      if (!card || !source || !this.dialog || typeof this.dialog.showModal !== 'function') return;
      const image = this.dialog.querySelector('[data-preview-image]');
      image.src = card.dataset.imageFull || source.currentSrc || source.src;
      image.alt = card.dataset.name;
      this.dialog.querySelector('[data-preview-title]').textContent = card.dataset.name;
      this.dialog.querySelector('[data-preview-size]').textContent = card.dataset.size;
      this.previewTrigger = button;
      this.dialog.showModal();
      this.dialog.querySelector('[data-preview-close]').focus();
      this.scheduleSticky();
    }
    offerHasExpired() {
      const banner = [...document.querySelectorAll('atelier-hero-offer-banner')].find(element => element.dataset.productId === this.dataset.productId);
      const deadline = banner ? Date.parse(banner.dataset.deadline) : NaN;
      return Number.isFinite(deadline) && Date.now() >= deadline;
    }
    applyOfferExpiry() {
      if (!this.offerHasExpired()) return false;
      this.querySelectorAll('[data-builder-form] button[type="submit"], [data-fallback] button[type="submit"]').forEach(button => { button.disabled = true; });
      if (this.stickyButton) this.stickyButton.disabled = true;
      const variantInput = this.querySelector('[data-variant]');
      if (variantInput) variantInput.value = '';
      const feedback = this.querySelector('[data-feedback]');
      if (feedback) feedback.textContent = this.dataset.offerExpired;
      const fallbackMessage = this.querySelector('[data-offer-expired-message]');
      if (fallbackMessage) fallbackMessage.hidden = this.classList.contains('is-ready');
      if (this.cards) this.cards.forEach(card => { card.setAttribute('aria-disabled', 'true'); });
      this.scheduleSticky();
      return true;
    }
    validPair(pair) {
      const ironKeys = ['mark_v', 'infinity_armor', 'ironman_210'];
      return Boolean(pair && pair.variant && pair.variant.available && this.selected.length === 2 && new Set(this.selected).size === 2 && this.selected.filter(key => ironKeys.includes(key)).length <= 1);
    }
    async handleSubmit(event) {
      const form = event.target;
      if (!form.matches('[data-builder-form], [data-fallback]')) return;
      if (this.pending || this.offerHasExpired()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.applyOfferExpiry();
        return;
      }
      if (!form.matches('[data-builder-form]')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const pair = this.initialized ? this.match(this.selected) : null;
      if (!this.initialized || !this.validPair(pair)) {
        if (this.initialized) this.update();
        return;
      }
      this.variantInput.value = String(pair.id);
      this.pending = true;
      this.clearCartStatus();
      this.syncPurchaseState();
      this.requestAbort = new AbortController();
      this.requestTimeout = setTimeout(() => this.requestAbort && this.requestAbort.abort(), 20000);
      let confirmed = false;
      try {
        const body = new FormData();
        body.set('id', String(pair.id));
        body.set('quantity', '1');
        body.set('sections', 'mini-cart');
        const addUrl = new URL(form.action, window.location.href);
        addUrl.pathname = addUrl.pathname.replace(/\.js$/, '') + '.js';
        const response = await fetch(addUrl.href, { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body, signal: this.requestAbort.signal });
        if (response.status >= 500) throw new Error('Unconfirmed cart result');
        if (!response.ok) {
          const error = await response.json().catch(() => null);
          this.setCartStatus(error && typeof error.description === 'string' ? error.description : this.config.addError, true);
          return;
        }
        confirmed = true;
        const added = await response.json();
        if (!this.isConnected) return;
        this.dispatchEvent(new CustomEvent('variant:added', { bubbles: true, detail: { variant: Array.isArray(added.items) ? added.items[0] : added } }));
        const cartUrl = new URL(this.dataset.cartUrl, window.location.href);
        cartUrl.pathname = cartUrl.pathname.replace(/\.js$/, '') + '.js';
        const cartResponse = await fetch(cartUrl.href, { credentials: 'same-origin', headers: { 'Accept': 'application/json' }, signal: this.requestAbort.signal });
        if (!cartResponse.ok) throw new Error('Cart refresh failed');
        const cart = await cartResponse.json();
        const html = added.sections && added.sections['mini-cart'];
        const fragment = document.createElement('template');
        if (typeof html === 'string') fragment.innerHTML = html;
        const renderedDrawer = fragment.content.querySelector('cart-drawer');
        const drawer = document.getElementById('mini-cart');
        if (!Array.isArray(cart.items) || !Number.isFinite(cart.item_count) || !renderedDrawer || !renderedDrawer.querySelector('.drawer__content') || !drawer || !customElements.get('cart-drawer')) throw new Error('Cart section unavailable');
        cart.sections = { 'mini-cart': html };
        this.cartOpening = true;
        this.scheduleSticky();
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart, openMiniCart: true } }));
        this.setCartStatus(this.config.added, false);
        clearTimeout(this.cartOpenTimer);
        this.cartOpenTimer = setTimeout(() => {
          if (this.isConnected && this.cartOpening && !drawer.hasAttribute('open')) window.location.assign(this.dataset.cartUrl);
        }, 1500);
      } catch (error) {
        if (!this.isConnected) return;
        if (confirmed) window.location.assign(this.dataset.cartUrl);
        else this.setCartStatus(this.config.uncertainError, true);
      } finally {
        clearTimeout(this.requestTimeout);
        this.requestAbort = null;
        this.pending = false;
        if (this.isConnected) this.update();
      }
    }
    setCartStatus(message, error) {
      this.cartMessage = message;
      this.cartError = Boolean(error);
      if (this.feedback) this.feedback.textContent = message;
      const container = this.querySelector('[data-cart-feedback]');
      if (!container) return;
      container.hidden = false;
      container.classList.toggle('is-error', Boolean(error));
      this.querySelector('[data-cart-message]').textContent = message;
    }
    clearCartStatus() {
      this.cartMessage = '';
      this.cartError = false;
      const container = this.querySelector('[data-cart-feedback]');
      if (container) container.hidden = true;
      const message = this.querySelector('[data-cart-message]');
      if (message) message.textContent = '';
    }
    syncPurchaseState() {
      if (!this.initialized) return;
      const expired = this.offerHasExpired();
      const ready = !expired && this.validPair(this.match(this.selected));
      const buttons = [...this.querySelectorAll('[data-builder-form] button[type="submit"], [data-fallback] button[type="submit"]')];
      if (this.stickyButton) buttons.push(this.stickyButton);
      buttons.forEach(button => {
        button.disabled = Boolean(this.pending || expired || (!button.closest('[data-fallback]') && !ready));
        button.setAttribute('aria-busy', String(Boolean(this.pending)));
        const label = button.querySelector('[data-add-label]');
        if (label) label.textContent = this.pending ? this.config.adding : this.config.addLabel;
      });
      this.querySelectorAll('[data-hero], [data-reset], [data-remove], [data-fallback] select').forEach(control => { control.disabled = Boolean(this.pending || expired); });
      if (this.pending && this.feedback) this.feedback.textContent = this.config.adding;
      if (this.stickyStatus) this.stickyStatus.textContent = expired ? this.dataset.offerExpired : this.pending ? this.config.adding : this.cartError ? this.config.cartIssue : ready ? '2 / 2 ' + this.config.countLabel : this.selected.length ? this.config.chooseSecond : this.config.chooseFirst;
      if (this.stickyCartLink) this.stickyCartLink.hidden = !this.cartError;
      this.scheduleSticky();
    }
    setupSticky(signal) {
      this.teardownSticky();
      const template = this.querySelector('[data-sticky-template]');
      if (!template || !template.content.firstElementChild) return;
      this.stickyBar = template.content.firstElementChild.cloneNode(true);
      this.stickyButton = this.stickyBar.querySelector('[data-sticky-submit]');
      this.stickyStatus = this.stickyBar.querySelector('[data-sticky-status]');
      this.stickyCartLink = this.stickyBar.querySelector('[data-sticky-cart-link]');
      document.body.append(this.stickyBar);
      const refresh = () => this.scheduleSticky();
      window.addEventListener('scroll', refresh, { passive: true, signal });
      window.addEventListener('resize', refresh, { passive: true, signal });
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', refresh, { passive: true, signal });
        window.visualViewport.addEventListener('scroll', refresh, { passive: true, signal });
      }
      if ('IntersectionObserver' in window) {
        this.purchaseObserver = new IntersectionObserver(refresh, { threshold: [0, 1] });
        this.purchaseObserver.observe(this);
        this.purchaseObserver.observe(this.purchaseForm);
      }
      if ('ResizeObserver' in window) {
        this.purchaseResize = new ResizeObserver(refresh);
        this.purchaseResize.observe(this.querySelector('.hc-shell'));
        this.purchaseResize.observe(this.stickyBar);
      }
      this.overlayObserver = new MutationObserver(() => {
        const drawer = document.getElementById('mini-cart');
        if (drawer && drawer.hasAttribute('open')) {
          this.cartOpening = false;
          clearTimeout(this.cartOpenTimer);
        }
        refresh();
      });
      this.overlayObserver.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['open'] });
      this.scheduleSticky();
    }
    scheduleSticky() {
      if (!this.stickyBar || this.stickyFrame) return;
      this.stickyFrame = requestAnimationFrame(() => { this.stickyFrame = 0; this.updateSticky(); });
    }
    updateSticky() {
      if (!this.stickyBar || !this.purchaseForm || !this.isConnected) return;
      const viewport = window.visualViewport;
      const viewportBottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
      const viewportWidth = document.documentElement.clientWidth;
      const bounds = this.getBoundingClientRect();
      const shell = this.querySelector('.hc-shell').getBoundingClientRect();
      const panel = this.purchaseForm.getBoundingClientRect();
      const header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 68;
      const panelVisible = panel.bottom > header && panel.top < viewportBottom;
      const contentBottom = bounds.bottom - (this.stickySpace || 0);
      const overlay = this.cartOpening || document.querySelector('cart-drawer[open], .drawer[open], dialog[open]');
      const visible = !overlay && !this.offerHasExpired() && bounds.top < viewportBottom - 80 && contentBottom > viewportBottom && !panelVisible;
      const left = Math.max(0, shell.left);
      const width = Math.max(0, Math.min(viewportWidth, shell.right) - left);
      this.stickyBar.style.left = left + 'px';
      this.stickyBar.style.width = width + 'px';
      this.stickyBar.classList.toggle('is-narrow', width <= 749);
      this.stickyBar.hidden = !visible || width < 240;
      const space = this.stickyBar.hidden ? 0 : Math.ceil(this.stickyBar.getBoundingClientRect().height) + 12;
      if (space !== this.stickySpace) {
        this.stickySpace = space;
        this.style.setProperty('--hc-sticky-space', space + 'px');
      }
    }
    teardownSticky() {
      if (this.purchaseObserver) this.purchaseObserver.disconnect();
      if (this.purchaseResize) this.purchaseResize.disconnect();
      if (this.overlayObserver) this.overlayObserver.disconnect();
      if (this.stickyFrame) cancelAnimationFrame(this.stickyFrame);
      clearTimeout(this.cartOpenTimer);
      if (this.stickyBar) this.stickyBar.remove();
      this.stickyBar = null;
      this.stickyButton = null;
      this.stickyStatus = null;
      this.stickyCartLink = null;
      this.stickyFrame = 0;
      this.stickySpace = 0;
      this.cartOpening = false;
      this.style.removeProperty('--hc-sticky-space');
    }
    match(keys) { return keys.length === 2 ? this.pairs.find(pair => pair.keys.every(key => keys.includes(key))) : null; }
    toggle(key) {
      if (this.pending || this.applyOfferExpiry()) return;
      if (!this.cards.some(card => card.dataset.hero === key)) return;
      if (this.selected.includes(key)) { this.clearCartStatus(); this.selected = this.selected.filter(item => item !== key); this.update(); return; }
      if (this.selected.length >= 2) { this.feedback.textContent = this.dataset.full; return; }
      if (['mark_v','infinity_armor','ironman_210'].includes(key) && this.selected.some(item => ['mark_v','infinity_armor','ironman_210'].includes(item))) { this.feedback.textContent = this.dataset.iron; return; }
      const next = [...this.selected, key];
      if (next.length === 2) { const pair = this.match(next); if (!pair || !pair.variant || !pair.variant.available) { this.feedback.textContent = this.dataset.unavailable; return; } }
      this.clearCartStatus();
      this.selected = next;
      this.update();
    }
    update() {
      const pair = this.match(this.selected);
      const expired = this.offerHasExpired();
      const ready = !expired && this.validPair(pair);
      this.querySelector('[data-count]').textContent = String(this.selected.length);
      this.querySelector('[data-count-label]').setAttribute('aria-label', this.selected.length + ' / 2 ' + this.config.countLabel);
      this.variantInput.value = ready ? String(pair.id) : '';
      this.reserve.disabled = this.pending || !ready;
      this.feedback.textContent = expired ? this.dataset.offerExpired : this.cartMessage ? this.cartMessage : ready ? this.config.readyToAdd : this.selected.length ? this.config.chooseSecond : this.config.chooseFirst;
      this.cards.forEach(card => {
        const selected = this.selected.includes(card.dataset.hero);
        card.setAttribute('aria-pressed', String(selected));
        card.setAttribute('aria-label', (selected ? this.config.removeLabel : this.config.selectLabel) + ' ' + card.dataset.name);
        card.querySelector('[data-action]').textContent = selected ? this.config.selectedLabel : this.config.selectLabel;
        const conflict = !selected && (this.selected.length === 2 || (['mark_v','infinity_armor','ironman_210'].includes(card.dataset.hero) && this.selected.some(key => ['mark_v','infinity_armor','ironman_210'].includes(key))));
        card.setAttribute('aria-disabled', String(expired || conflict));
      });
      const slots = this.querySelector('[data-slots]');
      slots.replaceChildren();
      for (let index = 0; index < 2; index += 1) {
        const slot = document.createElement('div');
        slot.className = 'hc-slot';
        const key = this.selected[index];
        const card = key ? this.cards.find(item => item.dataset.hero === key) : null;
        if (card) {
          const source = card.querySelector('img');
          if (source) {
            const image = source.cloneNode(true);
            image.removeAttribute('srcset'); image.removeAttribute('sizes'); image.alt = ''; image.setAttribute('aria-hidden','true');
            slot.append(image);
          } else {
            const placeholder = document.createElement('span'); placeholder.setAttribute('aria-hidden','true'); slot.append(placeholder);
          }
          const label = document.createElement('strong'); label.textContent = card.dataset.name;
          const remove = document.createElement('button'); remove.type = 'button'; remove.className = 'hc-remove'; remove.dataset.remove = key;
          remove.setAttribute('aria-label', this.config.removeLabel + ' ' + card.dataset.name);
          const symbol = document.createElement('span'); symbol.setAttribute('aria-hidden','true'); symbol.textContent = '×'; remove.append(symbol);
          slot.append(label, remove);
        } else {
          slot.classList.add('hc-slot-empty'); slot.append(document.createTextNode('0' + (index + 1)));
          const label = document.createElement('span'); label.textContent = this.config.emptySlot; slot.append(label);
        }
        slots.append(slot);
      }
      this.applyOfferExpiry();
      this.syncPurchaseState();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
